import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { EducationFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: EducationFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText
        label="Special Education Services & IEP"
        value={formValues.specialEducationServices}
      />
    </Grid>
  );
};

export default ViewFields;
